import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
}), 'DragHandle');